@import '../../../globals/main.scss';

pn-titletag {
  display: inline-flex;
  border-radius: 0.4rem;
  min-height: 2.5em;
  font-weight: normal;
  font-size: 0.75em;
  text-align: center;
  vertical-align: bottom;
  padding: 0.6rem;
  gap: 0.6em;

  pn-icon {
  }

  &[color='green700'],
  &[color='green'] {
    color: $green700;
    background: $green50;
  }

  &[color='blue700'],
  &[color='blue'] {
    background: $blue50;
    color: $blue700;
  }

  &[color='coral700'],
  &[color='coral'] {
    background: $coral50;
    color: $coral700;
  }

  &[color='gray900'],
  &[color='gray'],
  &[color='grey'] {
    background: $gray200;
    color: $gray900;
  }

  &[color='gray50'],
  &[color='lightgray'],
  &[color='lightgrey'] {
    background: $gray50;
    color: $gray900;
  }
}
